module.exports = __webpack_public_path__ + "static/media/researchs.ef254998.webp";